import {
  setMergedColRowSpanKey,
  transformMergeCellsToRowColSpanResult,
  calculateEqualMergeCells,
} from '../config/merge-cell'
import { getValue } from '../../utils/tools'

export default {
  data() {
    return {
      states: {
        mergeRowspanMaps: {
          // '0, 1, 2': {
          //   mergeIndex: [0, 1, 2],
          //   mergeSum: 3
          // },
          // '3, 4, 5': {
          //   mergeIndex: [3, 4, 5],
          //   mergeSum: 3
          // },
        },
        mergedColRowSpanResult: {
          // rowIndex - columnIndex: {}
        },
        mergeColspanMaps: {},
        // lastIndexMergeMaps: {},
        equalCellsMap: {},
      },
    }
  },
  methods: {
    setMergedColRowSpanKey,
    // 获取合并行列的key值。
    getColRowSpanResult(rowIndex, columnIndex) {
      const key = setMergedColRowSpanKey(rowIndex, columnIndex)
      return this.states.mergedColRowSpanResult[key]
    },
    // 存储合并行列的结果集。以 rowIndex、columnIndex为维度
    setMergedColRowSpanResult({ rowIndex, columnIndex, colRowSpan }) {
      const key = setMergedColRowSpanKey(rowIndex, columnIndex)
      this.states.mergedColRowSpanResult[key] = colRowSpan
    },
    // 执行props的 spanMethods 回调(在数据变更时执行)。存储回调结果。
    calculateSpanMethods(rowData, rowIndex, tableData) {
      if (!this.table.$props.spanMethod) {
        return
      }
      const columns = this.states.mainColumns.filter(
        (i) => !(i.children && i.children.length)
      )
      if (columns) {
        for (let i = 0; i < columns.length; i++) {
          const column = columns[i]
          // 使用原始的索引值去做合并列的计算。否则导致位置偏移
          const columnIndex = column.originIndex
          const result = this.table.$props.spanMethod({
            rowData,
            column,
            rowIndex,
            columnIndex,
            tableData,
          })
          const colRowSpan = {
            rowspan: 1,
            colspan: 1,
          }
          if (Array.isArray(result)) {
            colRowSpan.rowspan = result[0]
            colRowSpan.colspan = result[1]
          } else if (typeof result === 'object') {
            colRowSpan.rowspan = result.rowspan
            colRowSpan.colspan = result.colspan
          }
          this.setMergedColRowSpanResult({
            rowIndex,
            columnIndex,
            colRowSpan,
          })
          this.saveMergeCellConfig({
            colRowSpan,
            rowData,
            column,
            rowIndex,
            columnIndex,
          })
        }
      }
    },
    clearEqualCellsMap() {
      this.states.equalCellsMap = {}
    },
    getEqualCellsMap(rowData, rowIndex, tableData) {
      const mergeEqualCellsOption = this.table.$props.mergeEqualCellsOption
      if (!mergeEqualCellsOption) {
        return
      }
      const { beforeMergeValue, beforeMergeKey = [] } = mergeEqualCellsOption
      const columns = this.states.mainColumns.filter(
        (i) => !(i.children && i.children.length)
      )
      if (columns) {
        for (let i = 0; i < columns.length; i++) {
          const column = columns[i]
          const { key, originIndex: columnIndex } = column
          // 使用原始的索引值去做合并列的计算。否则导致位置偏移
          if (['_index'].includes(key)) {
            continue
          }
          let mergeKey = typeof beforeMergeKey === 'function' && beforeMergeKey({column, rowData, columnIndex, rowIndex, tableData})
          let cellValue = getValue(mergeKey || key, rowData)
          if (beforeMergeValue && typeof beforeMergeValue === 'function') {
            cellValue = beforeMergeValue({column, rowData, value: cellValue, rowIndex, columnIndex, tableData})
          }
          // undefined null NaN不做处理
          if (cellValue === undefined || cellValue === null) {
            continue
          }
          // 为什么要加 key。为了防止。多个key下相同的数据，导致key不同而产生合并的问题出现
          cellValue = key + '_' + cellValue
          if (!this.states.equalCellsMap[cellValue]) {
            this.states.equalCellsMap[cellValue] = {
              row: {},
              col: {},
              key,
              column,
              tableData
            }
          }
          if (!this.states.equalCellsMap[cellValue]['row'][rowIndex]) {
            this.states.equalCellsMap[cellValue]['row'][rowIndex] = []
          }
          if (!this.states.equalCellsMap[cellValue]['col'][columnIndex]) {
            this.states.equalCellsMap[cellValue]['col'][columnIndex] = []
          }
          // 行记录列
          this.states.equalCellsMap[cellValue]['row'][rowIndex].push(
            columnIndex
          )
          // 列记录行
          this.states.equalCellsMap[cellValue]['col'][columnIndex].push(
            rowIndex
          )
        }
      }
    },
    transformMergeCellsToRowColSpanResult(mergeCells) {
      const obj = transformMergeCellsToRowColSpanResult(mergeCells)
      if (!obj) {
        return
      }
      const {
        mergeColspanMaps = {},
        mergeRowspanMaps = {},
        mergedColRowSpanResult = {},
      } = obj
      this.states.mergeColspanMaps = mergeColspanMaps
      this.states.mergeRowspanMaps = mergeRowspanMaps
      this.states.mergedColRowSpanResult = mergedColRowSpanResult
    },
    calculateEqualMergeCells() {
      const equalCellsMap = this.states.equalCellsMap
      const mergeEqualCellsOption = this.table.$props.mergeEqualCellsOption
      const mergeCells = this.table.$props.mergeCells
      if (mergeCells) {
        this.transformMergeCellsToRowColSpanResult(mergeCells)
      } else {
        if (Object.keys(equalCellsMap).length) {
          const mergeCells = calculateEqualMergeCells(
            equalCellsMap,
            mergeEqualCellsOption
          )
          this.transformMergeCellsToRowColSpanResult(mergeCells)
        }
      }
    },
    // 清除合并列与合并行
    clearMergeRowColspanMap() {
      this.states.mergeRowspanMaps = {}
      this.states.mergeColspanMaps = {}
      this.states.mergedColRowSpanResult = {}
    },
    // 设置合并列与合并行
    saveMergeCellConfig(data) {
      const { colRowSpan = {}, rowIndex, columnIndex } = data || {}
      const { rowspan, colspan } = colRowSpan
      if (rowspan > 1) {
        const mergeIndex = Array.from(
          { length: rowspan },
          (_, index) => index + rowIndex
        )
        const mergeCellKey = mergeIndex.join(',')
        this.states.mergeRowspanMaps[mergeCellKey] = {
          mergeSum: rowspan,
          mergeIndex,
          mergeStartIndex: mergeIndex[0],
          mergeEndIndex: mergeIndex[mergeIndex.length - 1],
        }
      }
      if (colspan > 1) {
        const mergeIndex = Array.from(
          { length: colspan },
          (_, index) => index + columnIndex
        )
        const mergeCellKey = mergeIndex.join(',')
        this.states.mergeColspanMaps[mergeCellKey] = {
          mergeSum: colspan,
          mergeIndex,
          mergeStartIndex: mergeIndex[0],
          mergeEndIndex: mergeIndex[mergeIndex.length - 1],
        }
      }
    },
    // 计算索引值 是否在 cellMap的合并集合内。存在则返回对应 合并起始值与区间集合
    computedMergeCell(index, cellMap = {}) {
      const mergeCellKeys = Object.keys(cellMap)
      const mergeCellKey = mergeCellKeys.findIndex(
        (ids) =>
          ids.split(',').length && ids.split(',').some((id) => +id === index)
      )
      if (!mergeCellKeys.length || mergeCellKey === -1) return false
      const mergeKey = mergeCellKeys[mergeCellKey]
      const mergeItem = cellMap[mergeKey]
      return {
        mergeCellStart: mergeItem.mergeIndex[0], // 保证每一组都能被正常渲染出来
        mergeIndex: mergeItem.mergeIndex,
      }
    },
    // 计算纵向结束区间值是否为合并列中的一员，是否返回当前位置后面剩下的长度个数，补齐未渲染的个数。
    computedRangeEndInMergedCell(end, cellMap = {}) {
      // 如果虚拟列表区间的结束值，包含在合并的列中，且不是最后一项，则需要计算其他的子项。因为合并需要展示完全
      const mergeCellKeys = Object.keys(cellMap)
      const mergeCellKey = mergeCellKeys.findIndex((ids) => {
        const idsArray = ids.split(',')
        return idsArray.length && idsArray.some((id) => +id === end)
      })
      if (!mergeCellKeys.length || mergeCellKey === -1) return 0
      const mergeKey = mergeCellKeys[mergeCellKey]
      const mergeItem = cellMap[mergeKey]
      const length =
        mergeItem.mergeIndex.length -
        (mergeItem.mergeIndex.findIndex((i) => i === end) + 1)
      return length
    },
  },
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/store/modules/merge-cell.js